import React from "react";
import { ExclamationCircleIcon } from "@heroicons/react/solid";
import { Label } from "./Common";
import { areVideoAndAudioQuotasCombined } from "../../../feature-flags/prodFeatureFlags";

const QuotaFormFields = ({ value = {}, onValueChange, error = {} }) => {
  const handleFieldChange = (fieldName, fieldValue) => {
    const numericValue = fieldValue === "" ? null : parseInt(fieldValue, 10);
    const updatedValue = {
      ...value,
      [fieldName]: isNaN(numericValue) ? null : numericValue
    };
    onValueChange(updatedValue);
  };

  const getFieldValue = fieldName => {
    return value[fieldName] !== null && value[fieldName] !== undefined
      ? value[fieldName].toString()
      : "";
  };

  const getFieldError = fieldName => {
    return error && error[fieldName];
  };

  const renderQuotaField = (fieldName, label, tooltipContent, placeholder) => {
    const hasError = getFieldError(fieldName);
    const fieldValue = getFieldValue(fieldName);

    return (
      <div className="mt-6" id={`${fieldName}-input-div`}>
        <Label htmlFor={fieldName} tooltipContent={tooltipContent}>
          {label}
        </Label>
        <div className="mt-1 rounded-md text-gray-800 shadow-sm relative">
          <input
            id={fieldName}
            name={fieldName}
            type="number"
            min="0"
            className={`${
              hasError
                ? "border-red-300 text-red-300 focus:border-red-300 focus:shadow-outline-red"
                : "border-gray-300 focus:shadow-outline-blue focus:border-blue-300"
            } block w-full px-3 py-2 border rounded-md focus:outline-none transition duration-150 ease-in-out sm:text-sm sm:leading-5`}
            value={fieldValue}
            onChange={e => handleFieldChange(fieldName, e.target.value)}
            placeholder={placeholder}
          />
          {hasError && (
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              <ExclamationCircleIcon className="w-5 text-red-600" />
            </div>
          )}
        </div>
        {hasError && <p className="mt-2 text-sm text-red-600">{hasError}</p>}
      </div>
    );
  };

  return (
    <div className="quota-form-fields">
      <h4 className="text-lg font-medium text-gray-900 mb-4">User Quotas</h4>

      {renderQuotaField(
        "videoUploadsPerMonth",
        areVideoAndAudioQuotasCombined
          ? "Video or Audio Uploads Per Month"
          : "Video Uploads Per Month",
        `Maximum number of ${
          areVideoAndAudioQuotasCombined ? "video or audio contents" : "videos"
        } this user can upload per month. Set to 0 to disable uploads. Leave blank for unlimited. *This limit does not apply to course lessons. `,
        "Leave blank for unlimited"
      )}

      {renderQuotaField(
        "booksTotal",
        "Books Total",
        "Maximum total number of books this user can have. Set to 0 to disable uploads. Leave blank for unlimited.",
        "Leave blank for unlimited"
      )}

      {renderQuotaField(
        "courseTotal",
        "Course Total",
        "Maximum total number of courses this user can have. Set to 0 to disable. Leave blank for unlimited.",
        "Leave blank for unlimited"
      )}
    </div>
  );
};

export default QuotaFormFields;
